import React, { useRef, useState } from 'react';
import './UploadArea.css';

function UploadIconInline() {
  return (
    <svg className="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function TrashIcon() {
  return (
    <svg className="trash-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

const ACCEPTED_TYPES = ['image/png','image/jpeg','image/webp','image/gif'];
const ACCEPT_LABEL = 'PNG, JPG/JPEG, WEBP, GIF';

export default function UploadArea({ onImage, imageUrl, onError, onRemove, isPageLoaded }) {
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef();

  const processFile = (file) => {
    if (!file) return;
    if (!ACCEPTED_TYPES.includes(file.type)) {
      if (onError) onError(`Unsupported file type. Allowed: ${ACCEPT_LABEL}.`);
      return;
    }
    onImage(file);
  };

  const handleFiles = files => {
    if (files && files[0]) {
      processFile(files[0]);
    }
  };
  const onChange = e => handleFiles(e.target.files);
  const onDragOver = e => {
    e.preventDefault();
    setDragActive(true);
  };
  const onDragLeave = e => {
    e.preventDefault();
    setDragActive(false);
  };
  const onDrop = e => {
    e.preventDefault();
    setDragActive(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div
      className={dragActive ? 'upload-area active' : 'upload-area'}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={() => inputRef.current.click()}
    >
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        accept={ACCEPTED_TYPES.join(',')}
        onChange={onChange}
      />
      {imageUrl ? (
        <>
          <div className="upload-preview-wrapper">
            <img className="upload-preview-blur" src={imageUrl} alt="" />
            <img className="upload-preview" src={imageUrl} alt="Preview" />
          </div>
          <button
            type="button"
            className="remove-btn"
            onClick={(e) => { e.stopPropagation(); if (onRemove) onRemove(); }}
            aria-label="Remove image"
          >
            <TrashIcon />
          </button>
        </>
      ) : (
        <div className="upload-empty">
          <div className={`upload-empty-icon-wrapper ${isPageLoaded ? 'scale-up' : ''}`}>
            <img src="/emptyState.png" alt="" className="upload-empty-icon-blur" />
            <img src="/emptyState.png" alt="" className="upload-empty-icon" />
          </div>
          <p className="upload-text-desktop">Browse or drag & drop an image to extract its colors</p>
          <p className="upload-text-mobile">Select an image to extract its colors</p>
          <button
            type="button"
            className="upload-btn"
            onClick={(e) => { e.stopPropagation(); inputRef.current.click(); }}
          >
            <UploadIconInline />
            <span>Browse</span>
          </button>
        </div>
      )}
    </div>
  );
}
